<template>
  <div id="safe-manager">
    <div class="wrapper">
      <mainHeader class="mainHeader" v-if="showHeader"></mainHeader>
      <div :style="{marginTop:showHeader?'55px':'0px'}">
        <img v-for="(value, index) in images" :key="index" v-bind:src="value" />
      </div>
      <mainFooter class="mainFooter"  v-if="showHeader"></mainFooter>
      <bottomButton :show="true"  v-if="showHeader" id="bottomButton" title="中消通会员" state="1"  @click="bottomClick"></bottomButton>
    </div>
    <!--  支付弹窗  -->
    <payView type="1" :show="payViewVisible" @payValue="payValue"></payView>

  </div>
</template>

<script>
// import { Toast } from 'mint-ui'
import mainHeader from '../view/header'
import mainFooter from '../view/footer'
import payView from '../components/pay'
import bottomButton from '../components/bottom-button'

export default{
  data () {
    return {
      images: [
        'https://cdn.zxzx119.com/zxzx-mall-applet/myview/zx-svip/zx-svip-share.png',
        'https://cdn.zxzx119.com/zxzx-mall-applet/myview/zx-svip/zx-svip-img2.png',
        'https://cdn.zxzx119.com/zxzx-mall-applet/myview/zx-svip/zx-svip-img3.png',
        'https://cdn.zxzx119.com/zxzx-mall-applet/myview/zx-svip/zx-svip-img4.png'
      ],
      payViewVisible: false,
      isApp: 0,
      showHeader : true
    }
  },
  created() {
    if (this.$route.query.isApp == 1 || localStorage.getItem('isApp') == 1 || this.$route.query.isApp == 2 || localStorage.getItem('isApp') == 2) {
      this.showHeader = false
    } else { 
      this.showHeader = true
    }
  },
  methods: {
    payValue: function (state) {
      this.payViewVisible = false
      console.log('============支付回调')
    },
    bottomClick: function () {
      this.payViewVisible = true
    }
  },
  components: { // 注册组件
    mainHeader,
    mainFooter,
    payView,
    bottomButton
  },
  mounted () {
  }
}
</script>

<style scoped>
.wrapper{
  background-color: #F6F6F6;
  width: 100%;
  margin-bottom: 70px;
}
.mainHeader{
  position: fixed;
  top: 0px;
  height: 55px;
  width: 100%;
}
img{
  width: 100%;
  display: block;
}
/* img:first-of-type{
  margin-top: 55px;
} */
.mainFooter{
}
</style>



// WEBPACK FOOTER //
// src/view/zx-tong.vue